import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M13.853 6.146c-.195-.195-.512-.195-.707 0s-.195.512 0 .707L15.292 9H3.499c-.276 0-.5.222-.5.499s.224.501.5.501h11.793l-2.146 2.146a.5003.5003 0 0 0 0 .707.4985.4985 0 0 0 .707 0l3-3a.5003.5003 0 0 0 0-.707l-3-3z',
  ],
  height: 20,
  width: 20,
});
